import React, { useState, useRef, useEffect } from 'react';
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from 'js-cookie'; 

import Logo from '../assets/editortask_logo.png';
import Photosicon from '../assets/photos_icon.png'; 
import {
  MdOutlineSupportAgent, MdWorkHistory, MdFeed, MdOutlineFeed, MdLiveTv
} from "react-icons/md";
import { BsPlayBtn, BsPlayBtnFill, BsPersonWorkspace } from "react-icons/bs";
import { AiOutlineHome, AiFillHome } from "react-icons/ai";
import { RiSlideshowLine, RiSlideshowFill, RiAccountCircleLine } from "react-icons/ri";
import { FaMessage, FaRegMessage } from "react-icons/fa6";
import { BiSupport } from "react-icons/bi";
import './header-workstation.css';

export default function Headerworkstation() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [messages, setMessages] = useState(0);
  const [photoURL, setPhotoURL] = useState("");
  const [userlogin, setUserlogin] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    checkUserAuth(setUser);
    const existingUser = Cookies.get("guid");
    if (existingUser != null) {
      setUserlogin(true);
      const photo = Cookies.get("login_photoURL");
      setPhotoURL(photo);
    } else {
      setUserlogin(false);
    }
  }, []);

  const handleGoogleLogin = async () => {
    const userData = await signInWithGoogle();
    setUser(userData);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const handleGoogleLogout = async () => {
    await googleLogout();
    setUser(null);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="header-workstation">
     
 
        <div className="container_task_size">
          <div className='header_size'>
            <div className="left_body">
              <img onClick={() => navigate('/dashboard')} className="logo-img" src={Logo} alt="Logo" />
             
              <div onClick={() => navigate('/dashboard')} className='logo-div'>
                <a className='logo-text'>Editortask<br/><b className='logo-text2'>Work station</b></a>
              </div>
             
            </div> 
            <div className="menus_body"> 
            
            </div>

            <div className="right_body">
                    <div onClick={() => navigate('/upcoming-task')} className={`menubutton-icon ${location.pathname === '/upcoming-task' ? 'active' : ''}`} title="Upcoming task">
                {location.pathname === '/upcoming-task' ? <RiSlideshowFill className="icon" /> : <RiSlideshowLine className="icon" />}
                <span className="button-text">Upcoming</span> 
              </div>
                    <div onClick={() => navigate('/work-history')} className={`menubutton-icon ${location.pathname === '/work-history' ? 'active' : ''}`} title="My work">
                {location.pathname === '/work-history' ? <BsPersonWorkspace className="icon" /> : <BsPersonWorkspace className="icon" />}
                <span className="button-text">My work</span> 
              </div>
     <div onClick={() => navigate('/messageing')} className={`messageingmenubutton-icon ${location.pathname === '/messageing' ? 'active' : ''}`} title="Messaging">
                {location.pathname === '/messageing' ? <FaMessage className="icon" /> : <FaRegMessage className="icon" />}
                <span className="button-text">Alert</span>
                {messages > 0 && <span className='message_count'>{messages}</span>}
              </div>
              
                {userlogin ? (
                <img
                  onClick={() => navigate('/account')}
                  className="user-img"
                  src={photoURL}
                  alt="User"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = Photosicon;
                  }}
                />
              ) : (
                <div>
                
                </div>
              )}  
            </div>
          </div>
        </div>
      </div>
    
  );
}
